@for (renderKey of [phraseRenderKey()]; track renderKey) {
  <span class="animated-text" [class.visible]="phraseVisible()" [attr.data-render-key]="renderKey">
    {{ currentPhrase() | translate }}
  </span>
}
